document.addEventListener('DOMContentLoaded', function () {

  function calculateHMSleft() {

    var weekday = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    var monthday = ["January", "February", "March", "April", "May", "June",
                    "July", "August", "September", "October", "November", "December"];

    var now = new Date();
    var CUTOFF_HOUR = 15; // ✅ 15:59 cut-off (3:59 PM)

    function updateElements(HMSremainingId, deliverydayId) {

      var hmsEl = document.getElementById(HMSremainingId);
      var deliveryEl = document.getElementById(deliverydayId);
      if (!hmsEl || !deliveryEl) return;

      var today = new Date();
      var deliveryDate = new Date();

      /* ================= WEEKDAYS ================= */
      if (today.getDay() >= 1 && today.getDay() <= 5) {

        // Countdown to 15:59
        var cutoff = new Date();
        cutoff.setHours(CUTOFF_HOUR, 59, 59, 999);

        var diff = cutoff - now;
        if (diff < 0) diff += 24 * 60 * 60 * 1000;

        var hoursleft = Math.floor(diff / (1000 * 60 * 60));
        var minutesleft = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

        if (minutesleft < 10) minutesleft = "0" + minutesleft;

        if (hoursleft > 0) {
          hmsEl.innerHTML = hoursleft + " hours and " + minutesleft + " minutes";
        } else {
          hmsEl.innerHTML = minutesleft + " minutes";
        }

        // Delivery logic
        if (now > cutoff) {
          // After cutoff
          if (today.getDay() >= 1 && today.getDay() <= 4) {
            deliveryDate.setDate(deliveryDate.getDate() + 2);
          } else if (today.getDay() === 5) {
            deliveryDate.setDate(deliveryDate.getDate() + 3);
          }
        } else {
          // Before cutoff
          deliveryDate.setDate(deliveryDate.getDate() + 1);
        }

      /* ================= WEEKENDS ================= */
      } else {

        // Weekend cutoff 10:59
        var weekendCutoff = new Date();
        weekendCutoff.setHours(10, 59, 59, 999);

        var diffW = weekendCutoff - now;
        if (diffW < 0) diffW += 24 * 60 * 60 * 1000;

        var hoursleftW = Math.floor(diffW / (1000 * 60 * 60));
        var minutesleftW = Math.floor((diffW % (1000 * 60 * 60)) / (1000 * 60));

        if (minutesleftW < 10) minutesleftW = "0" + minutesleftW;

        if (hoursleftW > 0) {
          hmsEl.innerHTML = hoursleftW + " hours and " + minutesleftW + " minutes";
        } else {
          hmsEl.innerHTML = minutesleftW + " minutes";
        }

        // Weekend delivery → Monday
        if (today.getDay() === 6) {
          deliveryDate.setDate(deliveryDate.getDate() + 2);
        } else {
          deliveryDate.setDate(deliveryDate.getDate() + 1);
        }
      }

      // Output delivery date
      deliveryEl.innerHTML =
        weekday[deliveryDate.getDay()] + " " +
        monthday[deliveryDate.getMonth()] + " " +
        deliveryDate.getDate();
    }

    updateElements('HMSremaining1', 'deliveryday1');
    updateElements('HMSremaining2', 'deliveryday2');
  }

  calculateHMSleft();
  setInterval(calculateHMSleft, 60000); // refresh every minute
});